import { defineComponent as Ii, h as Ri } from "vue";
var Ni = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ci(E) {
  return E && E.__esModule && Object.prototype.hasOwnProperty.call(E, "default") ? E.default : E;
}
var wi = { exports: {} };
(function(E, q) {
  (function(A, m) {
    var F = "1.0.37", M = "", I = "?", R = "function", V = "undefined", ii = "object", j = "string", li = "major", e = "model", a = "name", i = "type", o = "vendor", t = "version", v = "architecture", B = "console", n = "mobile", b = "tablet", h = "smarttv", N = "wearable", ei = "embedded", oi = 500, G = "Amazon", D = "Apple", di = "ASUS", mi = "BlackBerry", T = "Browser", H = "Chrome", yi = "Edge", X = "Firefox", Y = "Google", ui = "Huawei", ai = "LG", ti = "Microsoft", pi = "Motorola", K = "Opera", Z = "Samsung", hi = "Sharp", J = "Sony", ri = "Xiaomi", si = "Zebra", fi = "Facebook", vi = "Chromium OS", gi = "Mac OS", Ti = function(c, l) {
      var s = {};
      for (var d in c)
        l[d] && l[d].length % 2 === 0 ? s[d] = l[d].concat(c[d]) : s[d] = c[d];
      return s;
    }, Q = function(c) {
      for (var l = {}, s = 0; s < c.length; s++)
        l[c[s].toUpperCase()] = c[s];
      return l;
    }, Ei = function(c, l) {
      return typeof c === j ? U(l).indexOf(U(c)) !== -1 : !1;
    }, U = function(c) {
      return c.toLowerCase();
    }, _i = function(c) {
      return typeof c === j ? c.replace(/[^\d\.]/g, M).split(".")[0] : m;
    }, ni = function(c, l) {
      if (typeof c === j)
        return c = c.replace(/^\s\s*/, M), typeof l === V ? c : c.substring(0, oi);
    }, L = function(c, l) {
      for (var s = 0, d, y, O, w, r, k; s < l.length && !r; ) {
        var ci = l[s], xi = l[s + 1];
        for (d = y = 0; d < ci.length && !r && ci[d]; )
          if (r = ci[d++].exec(c), r)
            for (O = 0; O < xi.length; O++)
              k = r[++y], w = xi[O], typeof w === ii && w.length > 0 ? w.length === 2 ? typeof w[1] == R ? this[w[0]] = w[1].call(this, k) : this[w[0]] = w[1] : w.length === 3 ? typeof w[1] === R && !(w[1].exec && w[1].test) ? this[w[0]] = k ? w[1].call(this, k, w[2]) : m : this[w[0]] = k ? k.replace(w[1], w[2]) : m : w.length === 4 && (this[w[0]] = k ? w[3].call(this, k.replace(w[1], w[2])) : m) : this[w] = k || m;
        s += 2;
      }
    }, bi = function(c, l) {
      for (var s in l)
        if (typeof l[s] === ii && l[s].length > 0) {
          for (var d = 0; d < l[s].length; d++)
            if (Ei(l[s][d], c))
              return s === I ? m : s;
        } else if (Ei(l[s], c))
          return s === I ? m : s;
      return c;
    }, Mi = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, Oi = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, ki = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [t, [a, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [t, [a, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [a, t],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [t, [a, K + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [t, [a, K]],
        [
          // Mixed
          /\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i
          // Baidu
        ],
        [t, [a, "Baidu"]],
        [
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant|iemobile|slim)\s?(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|qq|duckduckgo)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(heytap|ovi)browser\/([\d\.]+)/i,
          // Heytap/Ovi
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [a, t],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [t, [a, "UC" + T]],
        [
          /microm.+\bqbcore\/([\w\.]+)/i,
          // WeChat Desktop for Windows Built-in Browser
          /\bqbcore\/([\w\.]+).+microm/i,
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [t, [a, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [t, [a, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [t, [a, "IE"]],
        [
          /ya(?:search)?browser\/([\w\.]+)/i
          // Yandex
        ],
        [t, [a, "Yandex"]],
        [
          /slbrowser\/([\w\.]+)/i
          // Smart Lenovo Browser
        ],
        [t, [a, "Smart Lenovo " + T]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[a, /(.+)/, "$1 Secure " + T], t],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [t, [a, X + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [t, [a, K + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [t, [a, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [t, [a, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [t, [a, K + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [t, [a, "MIUI " + T]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [t, [a, X]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[a, "360 " + T]],
        [
          /(oculus|sailfish|huawei|vivo)browser\/([\w\.]+)/i
        ],
        [[a, /(.+)/, "$1 " + T], t],
        [
          // Oculus/Sailfish/HuaweiBrowser/VivoBrowser
          /samsungbrowser\/([\w\.]+)/i
          // Samsung Internet
        ],
        [t, [a, Z + " Internet"]],
        [
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[a, /_/g, " "], t],
        [
          /metasr[\/ ]?([\d\.]+)/i
          // Sogou Explorer
        ],
        [t, [a, "Sogou Explorer"]],
        [
          /(sogou)mo\w+\/([\d\.]+)/i
          // Sogou Mobile
        ],
        [[a, "Sogou Mobile"], t],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/2345 Browser
        ],
        [a, t],
        [
          /(lbbrowser)/i,
          // LieBao Browser
          /\[(linkedin)app\]/i
          // LinkedIn App for iOS & Android
        ],
        [a],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[a, fi], t],
        [
          /(Klarna)\/([\w\.]+)/i,
          // Klarna Shopping Browser for iOS & Android
          /(kakao(?:talk|story))[\/ ]([\w\.]+)/i,
          // Kakao App
          /(naver)\(.*?(\d+\.[\w\.]+).*\)/i,
          // Naver InApp
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(alipay)client\/([\w\.]+)/i,
          // Alipay
          /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram/Snapchat
        ],
        [a, t],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [t, [a, "GSA"]],
        [
          /musical_ly(?:.+app_?version\/|_)([\w\.]+)/i
          // TikTok
        ],
        [t, [a, "TikTok"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [t, [a, H + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[a, H + " WebView"], t],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [t, [a, "Android " + T]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [a, t],
        [
          /version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [t, [a, "Mobile Safari"]],
        [
          /version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [t, a],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [a, [t, bi, Mi]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [a, t],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[a, "Netscape"], t],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [t, [a, X + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i,
          // Links
          /panasonic;(viera)/i
          // Panasonic Viera
        ],
        [a, t],
        [
          /(cobalt)\/([\w\.]+)/i
          // Cobalt
        ],
        [a, [t, /master.|lts./, ""]]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[v, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[v, U]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[v, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[v, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[v, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[v, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[v, /ower/, M, U]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[v, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[v, U]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [e, [o, Z], [i, b]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|sc[g-]?[\d]+a?|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [e, [o, Z], [i, n]],
        [
          // Apple
          /(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i
          // iPod/iPhone
        ],
        [e, [o, D], [i, n]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [e, [o, D], [i, b]],
        [
          /(macintosh);/i
        ],
        [e, [o, D]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [e, [o, hi], [i, n]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [e, [o, ui], [i, b]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i
        ],
        [e, [o, ui], [i, n]],
        [
          // Xiaomi
          /\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i,
          // Xiaomi Redmi 'numeric' models
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[e, /_/g, " "], [o, ri], [i, n]],
        [
          /oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i,
          // Redmi Pad
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[e, /_/g, " "], [o, ri], [i, b]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [e, [o, "OPPO"], [i, n]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [e, [o, "Vivo"], [i, n]],
        [
          // Realme
          /\b(rmx[1-3]\d{3})(?: bui|;|\))/i
        ],
        [e, [o, "Realme"], [i, n]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [e, [o, pi], [i, n]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [e, [o, pi], [i, b]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [e, [o, ai], [i, b]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [e, [o, ai], [i, n]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [e, [o, "Lenovo"], [i, b]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[e, /_/g, " "], [o, "Nokia"], [i, n]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [e, [o, Y], [i, b]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [e, [o, Y], [i, n]],
        [
          // Sony
          /droid.+ (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [e, [o, J], [i, n]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[e, "Xperia Tablet"], [o, J], [i, b]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [e, [o, "OnePlus"], [i, n]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi|aeo[c-r]{2})( bui|\))/i,
          // Kindle Fire without Silk / Echo Show
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [e, [o, G], [i, b]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[e, /(.+)/g, "Fire Phone $1"], [o, G], [i, n]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [e, o, [i, b]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [e, [o, mi], [i, n]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [e, [o, di], [i, b]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [e, [o, di], [i, n]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [e, [o, "HTC"], [i, b]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [o, [e, /_/g, " "], [i, n]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [e, [o, "Acer"], [i, b]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [e, [o, "Meizu"], [i, n]],
        [
          // Ulefone
          /; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i
        ],
        [e, [o, "Ulefone"], [i, n]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [o, e, [i, n]],
        [
          /(kobo)\s(ereader|touch)/i,
          // Kobo
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [o, e, [i, b]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [e, [o, ti], [i, b]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [e, [o, "Fairphone"], [i, n]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [e, [o, "AT&T"], [i, n]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [e, [o, "Siemens"], [i, n]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [e, [o, "RCA"], [i, b]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [e, [o, "Dell"], [i, b]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [e, [o, "Verizon"], [i, b]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [e, [o, "Barnes & Noble"], [i, b]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [e, [o, "NuVision"], [i, b]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [e, [o, "ZTE"], [i, b]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [e, [o, "ZTE"], [i, n]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [e, [o, "Swiss"], [i, n]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [e, [o, "Swiss"], [i, b]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [e, [o, "Zeki"], [i, b]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[o, "Dragon Touch"], e, [i, b]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [e, [o, "Insignia"], [i, b]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [e, [o, "NextBook"], [i, b]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[o, "Voice"], e, [i, n]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[o, "LvTel"], e, [i, n]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [e, [o, "Essential"], [i, n]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [e, [o, "Envizen"], [i, b]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [e, [o, "MachSpeed"], [i, b]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [e, [o, "Rotor"], [i, b]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [e, [o, "Nvidia"], [i, b]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [o, e, [i, n]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[e, /\./g, " "], [o, ti], [i, n]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [e, [o, si], [i, b]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [e, [o, si], [i, n]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [o, [i, h]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[e, /^/, "SmartTV"], [o, Z], [i, h]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[o, ai], [i, h]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [o, [e, D + " TV"], [i, h]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[e, H + "cast"], [o, Y], [i, h]],
        [
          /droid.+aft(\w+)( bui|\))/i
          // Fire TV
        ],
        [e, [o, G], [i, h]],
        [
          /\(dtv[\);].+(aquos)/i,
          /(aquos-tv[\w ]+)\)/i
          // Sharp
        ],
        [e, [o, hi], [i, h]],
        [
          /(bravia[\w ]+)( bui|\))/i
          // Sony
        ],
        [e, [o, J], [i, h]],
        [
          /(mitv-\w{5}) bui/i
          // Xiaomi
        ],
        [e, [o, ri], [i, h]],
        [
          /Hbbtv.*(technisat) (.*);/i
          // TechniSAT
        ],
        [o, e, [i, h]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[o, ni], [e, ni], [i, h]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[i, h]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [o, e, [i, B]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [e, [o, "Nvidia"], [i, B]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [e, [o, J], [i, B]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [e, [o, ti], [i, B]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [o, e, [i, N]],
        [
          /(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i
          // Apple Watch
        ],
        [e, [o, D], [i, N]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [e, [o, Y], [i, N]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [e, [o, si], [i, N]],
        [
          /(quest( 2| pro)?)/i
          // Oculus Quest
        ],
        [e, [o, fi], [i, N]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [o, [i, ei]],
        [
          /(aeobc)\b/i
          // Echo Dot
        ],
        [e, [o, G], [i, ei]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [e, [i, n]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [e, [i, b]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[i, b]],
        [
          /(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[i, n]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [e, [o, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [t, [a, yi + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [t, [a, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i,
          // iCab
          /\b(libweb)/i
        ],
        [a, t],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [t, a]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [a, t],
        [
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i
          // Windows Phone
        ],
        [a, [t, bi, Oi]],
        [
          /windows nt 6\.2; (arm)/i,
          // Windows RT
          /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i,
          /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[t, bi, Oi], [a, "Windows"]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i,
          /cfnetwork\/.+darwin/i
        ],
        [[t, /_/g, "."], [a, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[a, gi], [t, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i
          // Android-x86/HarmonyOS
        ],
        [t, a],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [a, t],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [t, [a, mi]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [t, [a, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [t, [a, X + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [t, [a, "webOS"]],
        [
          /watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i
          // watchOS
        ],
        [t, [a, "watchOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [t, [a, H + "cast"]],
        [
          /(cros) [\w]+(?:\)| ([\w\.]+)\b)/i
          // Chromium OS
        ],
        [[a, vi], t],
        [
          // Smart TVs
          /panasonic;(viera)/i,
          // Panasonic Viera
          /(netrange)mmh/i,
          // Netrange
          /(nettv)\/(\d+\.[\w\.]+)/i,
          // NetTV
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [a, t],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[a, "Solaris"], t],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX/SerenityOS
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [a, t]
      ]
    }, g = function(c, l) {
      if (typeof c === ii && (l = c, c = m), !(this instanceof g))
        return new g(c, l).getResult();
      var s = typeof A !== V && A.navigator ? A.navigator : m, d = c || (s && s.userAgent ? s.userAgent : M), y = s && s.userAgentData ? s.userAgentData : m, O = l ? Ti(ki, l) : ki, w = s && s.userAgent == d;
      return this.getBrowser = function() {
        var r = {};
        return r[a] = m, r[t] = m, L.call(r, d, O.browser), r[li] = _i(r[t]), w && s && s.brave && typeof s.brave.isBrave == R && (r[a] = "Brave"), r;
      }, this.getCPU = function() {
        var r = {};
        return r[v] = m, L.call(r, d, O.cpu), r;
      }, this.getDevice = function() {
        var r = {};
        return r[o] = m, r[e] = m, r[i] = m, L.call(r, d, O.device), w && !r[i] && y && y.mobile && (r[i] = n), w && r[e] == "Macintosh" && s && typeof s.standalone !== V && s.maxTouchPoints && s.maxTouchPoints > 2 && (r[e] = "iPad", r[i] = b), r;
      }, this.getEngine = function() {
        var r = {};
        return r[a] = m, r[t] = m, L.call(r, d, O.engine), r;
      }, this.getOS = function() {
        var r = {};
        return r[a] = m, r[t] = m, L.call(r, d, O.os), w && !r[a] && y && y.platform != "Unknown" && (r[a] = y.platform.replace(/chrome os/i, vi).replace(/macos/i, gi)), r;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return d;
      }, this.setUA = function(r) {
        return d = typeof r === j && r.length > oi ? ni(r, oi) : r, this;
      }, this.setUA(d), this;
    };
    g.VERSION = F, g.BROWSER = Q([a, t, li]), g.CPU = Q([v]), g.DEVICE = Q([e, o, i, B, n, h, b, N, ei]), g.ENGINE = g.OS = Q([a, t]), E.exports && (q = E.exports = g), q.UAParser = g;
    var C = typeof A !== V && (A.jQuery || A.Zepto);
    if (C && !C.ua) {
      var $ = new g();
      C.ua = $.getResult(), C.ua.get = function() {
        return $.getUA();
      }, C.ua.set = function(c) {
        $.setUA(c);
        var l = $.getResult();
        for (var s in l)
          C.ua[s] = l[s];
      };
    }
  })(typeof window == "object" ? window : Ni);
})(wi, wi.exports);
var Pi = wi.exports;
const Bi = /* @__PURE__ */ Ci(Pi), S = {
  CONSOLE: "console",
  DESKTOP: void 0,
  EMBEDDED: "embedded",
  MOBILE: "mobile",
  SMART_TV: "smarttv",
  TABLET: "tablet",
  WEARABLE: "wearable"
}, _ = {
  ANDROID: "Android",
  IOS: "iOS",
  LINUX: "Linux",
  MAC_OS: "Mac OS",
  WINDOWS_PHONE: "Windows Phone",
  WINDOWS: "Windows"
}, p = {
  CHROME: "Chrome",
  CHROMIUM: "Chromium",
  EDGE_CHROMIUM: "Edge Chromium",
  EDGE: "Edge",
  FIREFOX: "Firefox",
  IE: "IE",
  INTERNET_EXPLORER: "Internet Explorer",
  MIUI: "MIUI Browser",
  MOBILE_SAFARI: "Mobile Safari",
  OPERA: "Opera",
  SAFARI: "Safari",
  SAMSUNG_BROWSER: "Samsung Browser",
  YANDEX: "Yandex"
}, z = new Bi(), f = z.getDevice(), x = z.getOS(), u = z.getBrowser(), Si = z.getEngine(), P = z.getUA(), W = () => /iPad/.test(P), Ai = () => x.name === _.WINDOWS && x.version === "10" && P.indexOf("Edg/") !== -1, Di = x.name === _.ANDROID, Ui = u.name === p.CHROME, Li = u.name === p.CHROMIUM, zi = f.type === S.CONSOLE, Wi = f.type === S.DESKTOP, qi = u.name === p.EDGE || Ai(), Fi = Ai(), Vi = u.name === p.EDGE, ji = /electron/.test(P.toLowerCase()), Gi = f.type === S.EMBEDDED, Hi = u.name === p.FIREFOX, Xi = u.name === p.INTERNET_EXPLORER || u.name === p.IE, Yi = x.name === _.IOS || W(), Ki = W(), Zi = /iPhone/.test(P), Ji = /iPod/.test(P), Qi = x.name === _.LINUX, $i = x.name === _.MAC_OS, ie = u.name === p.MIUI, ee = f.type === S.MOBILE || f.type === S.TABLET || W(), oe = f.type === S.MOBILE, ae = u.name === p.MOBILE_SAFARI || W(), te = u.name === p.OPERA, re = u.name === p.SAFARI || u.name === p.MOBILE_SAFARI, se = u.name === p.SAMSUNG_BROWSER, ne = f.type === S.SMART_TV, be = f.type === S.TABLET || W(), ce = f.type === S.WEARABLE, we = x.name === _.WINDOWS, le = x.name === _.WINDOWS_PHONE, de = u.name === p.YANDEX, pe = () => u.name, he = () => u.version, fe = () => f.model, ve = () => f.type || "desktop", ge = () => f.vendor, Ee = () => Si.name, Oe = () => Si.version, ke = () => P, xe = () => x.name, Se = () => x.version, me = {
  isAndroid: Di,
  isChrome: Ui,
  isChromium: Li,
  isConsole: zi,
  isDesktop: Wi,
  isEdge: qi,
  isEdgeChromium: Fi,
  isEdgeLegacy: Vi,
  isElectron: ji,
  isEmbedded: Gi,
  isFirefox: Hi,
  isIE: Xi,
  isIOS: Yi,
  isIPad: Ki,
  isIPhone: Zi,
  isIPod: Ji,
  isLinux: Qi,
  isMacOS: $i,
  isMIUI: ie,
  isMobile: ee,
  isMobileOnly: oe,
  isMobileSafari: ae,
  isOpera: te,
  isSafari: re,
  isSamsungBrowser: se,
  isSmartTV: ne,
  isTablet: be,
  isWearable: ce,
  isWindows: we,
  isWinPhone: le,
  isYandex: de
}, Ae = {
  install: (E) => {
    for (const [q, A] of Object.entries(me)) {
      const m = `${q.substring(2)}View`, F = Ii({
        name: m,
        props: {
          tagName: { type: String, default: "div" }
        },
        setup(M, { slots: I }) {
          return () => {
            var R;
            return A ? Ri(M.tagName, (R = I.default) == null ? void 0 : R.call(I)) : null;
          };
        }
      });
      E.component(F.name, F);
    }
  }
};
export {
  pe as browserName,
  he as browserVersion,
  Ae as default,
  fe as deviceModel,
  ve as deviceType,
  ge as deviceVendor,
  Ee as engineName,
  Oe as engineVersion,
  ke as getUA,
  Di as isAndroid,
  Ui as isChrome,
  Li as isChromium,
  zi as isConsole,
  Wi as isDesktop,
  qi as isEdge,
  Fi as isEdgeChromium,
  Vi as isEdgeLegacy,
  ji as isElectron,
  Gi as isEmbedded,
  Hi as isFirefox,
  Xi as isIE,
  Yi as isIOS,
  Ki as isIPad,
  Zi as isIPhone,
  Ji as isIPod,
  Qi as isLinux,
  ie as isMIUI,
  $i as isMacOS,
  ee as isMobile,
  oe as isMobileOnly,
  ae as isMobileSafari,
  te as isOpera,
  re as isSafari,
  se as isSamsungBrowser,
  ne as isSmartTV,
  be as isTablet,
  ce as isWearable,
  le as isWinPhone,
  we as isWindows,
  de as isYandex,
  xe as osName,
  Se as osVersion
};
